/**
 * Fallback only. The row's `payment_oasis_reason` says which assessment is
 * blocked (and what unblocks it) or that none exists; this is shown when the
 * server sent no reason.
 */
export const PAYMENT_OASIS_MISSING_MESSAGE =
  'No eligible payment OASIS is available for this billing period.';

/**
 * Shown when the payment OASIS that anchors the claim is history from the
 * agency's previous EMR (an externally billed prior episode). Roger neither
 * signed nor exported it, so it must never be described as locally signed.
 */
export const PAYMENT_OASIS_EXTERNAL_MESSAGE =
  'Payment OASIS from previous EMR (billed externally)';

/**
 * Row warning for the generated 0023 HIPPS line when the claim carries the
 * server's ``00000`` placeholder rather than a code the biller or the grouper
 * produced. ``00000`` is not a valid HIPPS code; the biller must replace it.
 * Sending a claim that still carries it is refused.
 */
export const EXTERNAL_DEFAULT_HIPPS_MESSAGE =
  'Placeholder HIPPS code. Replace 00000 with the correct HIPPS code from your previous EMR before sending.';

/**
 * Row warning for the generated 0023 HIPPS line when the grouper produced a
 * code from Roger's copy of an assessment the previous EMR billed. That copy
 * can be incomplete or unsigned, so the code may differ from what the previous
 * EMR actually billed; the biller must review it.
 */
export const EXTERNAL_COMPUTED_HIPPS_MESSAGE =
  'HIPPS code grouped from the previous EMR assessment as recorded in Roger. Review it against the HIPPS code your previous EMR billed.';

/**
 * Shown in place of the default warning once the biller has saved their own
 * FL44 code on the generated 0023 row for an external-history claim.
 */
export const EXTERNAL_MANUAL_HIPPS_LABEL = 'Biller-entered HIPPS';

/**
 * UB-04 FL14, the admission/priority type, as the claim carries it. The list
 * jumps from 5 to 9 because 6, 7 and 8 are unused on FL14.
 *
 * Not to be confused with the Kinnser admission-type select in
 * `useCreatePatientForm/constants.ts`, which numbers its own six options 1 to 6
 * and ends at `6 = Information not Available`. The two spaces agree on 1 to 5
 * and disagree on that last one, so anything reading an
 * `Admission.admission_type` (which is stored as FL14) must label it from here.
 */
export const UB04_ADMISSION_TYPE_OPTIONS = [
  { value: '1', label: '1 — Emergency' },
  { value: '2', label: '2 — Urgent' },
  { value: '3', label: '3 — Elective' },
  { value: '4', label: '4 — Newborn' },
  { value: '5', label: '5 — Trauma center' },
  { value: '9', label: '9 — Information not available' },
];
